import { ApolloError, useQuery } from '@apollo/client'
import { PublicProfileQuery, PublicProfileQueryVariables } from '../../types'

import { PUBLIC_PROFILE } from './Queries'

//usePublicProfile
export default (
  employeeId: string,
): {
  data: PublicProfileQuery | undefined
  error: ApolloError | undefined
  loading: boolean
} => {
  const { data, error, loading } = useQuery<PublicProfileQuery, PublicProfileQueryVariables>(PUBLIC_PROFILE, {
    variables: {
      id: employeeId,
    },
  })

  return { data, error, loading }
}
